import { useState, useMemo } from 'react'
import * as Dialog from '@radix-ui/react-dialog'
import { useTranslation } from 'react-i18next'
import { InputText } from '@/components/widget-components'
import { useBuySellStore } from '@/reducers/transactionReducer'
import { NetworkValue, NetworkOptions } from '@/utils/currencies'
import { useSupportedCurrencies } from '@/hooks/useSupportedCurrencies'
type NetworkProps = {
  onSelectNetwork: (network: NetworkValue) => void
}

//export const NetworkItems = ({}) => {
export const NetworkItems = ({ onSelectNetwork }: NetworkProps) => {
  const { t } = useTranslation()
  const [searchText, setSearchText] = useState('')
  const stableCoin = useBuySellStore.use.stableCoin()
  const supportedCurrencies = useSupportedCurrencies()
  const filteredOptions = useMemo(() => {
    return Object.entries(NetworkOptions).filter(
      ([networkValue, networkOption]) => {
        return (
          networkOption.name.toLowerCase().includes(searchText.toLowerCase()) &&
          supportedCurrencies[networkValue as NetworkValue].includes(stableCoin)
        )
      }
    )
  }, [searchText, stableCoin, supportedCurrencies])
  return (
    <div>
      <div
        className="text-l font-normal items-center"
        style={{
          textAlign: 'center',
        }}
      >
        {t('networkItems.title')}
      </div>
      <InputText
        placeholder={t('networkItems.search.placeholder')}
        onChange={(e) => setSearchText(e.target.value)}
        value={searchText}
      />
      <div className="flex flex-col items-start mt-2">
        {filteredOptions.map(([key, option]) => {
          //const clickedKey: NetworkValue = NetworkOptions[key];
          return (
            <Dialog.Close key={option.name} asChild>
              <div
                //onClick={() => setNetwork(key as NetworkValue)}
                onClick={() => onSelectNetwork(key as NetworkValue)}
                //onClick={(e) => console.log("KEY", e.target.innerText)}
                className="p-4 hover:border-px hover:bg-slate-200 hover:text-black dark:hover:text-black text-black dark:text-white"
                data-testid="container-networkitems"
              >
                <div className="flex gap-1 justify-left items-center md:w-[16rem]">
                  {option.icon && (
                    <div className="mr-1 md:mr-2">
                      <img src={option.icon} height={20} width={20} />
                    </div>
                  )}
                  {option.name}
                </div>
              </div>
            </Dialog.Close>
          )
        })}
      </div>
    </div>
  )
}
